import { render, staticRenderFns } from "./DeleteLUAFiles.vue?vue&type=template&id=1a209765&"
import script from "./DeleteLUAFiles.vue?vue&type=script&lang=ts&"
export * from "./DeleteLUAFiles.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports